import * as React from 'react';

import { PROJECT_MAPPING_RUN_SUGGESTIONS_PARAM } from 'src/constants/project';
import { projectSelector } from 'src/selectors/project';
import { useNavigate } from 'src/utils/hooks/useNavigate';
import { useNavigateProject } from 'src/utils/hooks/useNavigateProject';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';
import { getProjectMappingRoute } from 'src/utils/routes/getProjectMappingRoute';

export const useNavigateMapping = () => {
  const { projectId } = useRouterParams();
  const navigate = useNavigate();
  const navigateProject = useNavigateProject();
  const project = useReduxSelector(projectSelector(projectId));

  return React.useCallback(
    (mappingId: string | null, runSuggestions?: boolean) => {
      if (projectId && project) {
        const to = getProjectMappingRoute(projectId, mappingId || '');
        navigate(
          runSuggestions ? `${to}?${PROJECT_MAPPING_RUN_SUGGESTIONS_PARAM}` : to
        );
      } else {
        navigateProject(projectId);
      }
    },
    [navigate, navigateProject, project, projectId]
  );
};
